import TextButton from 'LuxKit/Button/TextButton'
import DropdownList from 'LuxKit/Dropdown/List/DropdownList'
import useToggle from 'hooks/useToggle'
import React, { forwardRef, useContext, useRef } from 'react'
import BusinessTravellerAccountMenuContent from './BusinessTravellerAccountMenuContent'
import { useScreenSizeOnly } from 'hooks/useScreenSize'
import Group from 'components/utils/Group'
import Caption from 'LuxKit/Typography/Caption'
import FormatCurrency from 'components/Common/FormatCurrency'
import { connect } from 'react-redux'
import GeoContext from 'contexts/geoContext'
import useBusinessTravellerTripRequestApprovals from 'businessTraveller/hooks/useBusinessTravellerTripRequestApprovals'
import Badge from 'LuxKit/Badge'
import { BUSINESS_TRAVELLER_MY_APPROVALS_PENDING_ROUTE } from 'components/App/Routes/routeConstants'
import { useAppSelector } from 'hooks/reduxHooks'
import { isBusinessTravellerTripRequestApprover } from 'businessTraveller/selectors/isBusinessTravellerTripRequestApprover'
import LineBuildingIcon from 'LuxKit/Icons/line/LineBuildingIcon'

interface Props {
  className?: string
  balance?: number
}

const MENU_TITLE = 'Your account'

const BusinessTravellerAccountButtonMenu = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { off, value, toggle } = useToggle()
  const accountButtonRef = useRef<HTMLButtonElement>(null)
  const isMobileScreen = useScreenSizeOnly('mobile')
  const { balance } = props
  const { currentRegionCode } = useContext(GeoContext)

  const isBusinessTravellerApprover = useAppSelector(isBusinessTravellerTripRequestApprover)
  const { pending: pendingApprovals } = useBusinessTravellerTripRequestApprovals({ currentRegionCode })

  const shouldShowIndicator = Boolean(pendingApprovals?.length && pendingApprovals?.length > 0)

  return <Group direction="horizontal" ref={ref}>
    {isBusinessTravellerApprover && <TextButton
      kind="primary"
      variant="ghost"
      to={BUSINESS_TRAVELLER_MY_APPROVALS_PENDING_ROUTE}
    >
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
        My Approvals
        {shouldShowIndicator && (
          <Badge
            kind="string"
            mode="critical"
          >
            {pendingApprovals?.length}
          </Badge>
        )}
      </span>
    </TextButton>}
    <TextButton
      kind="primary"
      variant="ghost"
      to="/account/my-bookings"
    >
      My Bookings
    </TextButton>
    <TextButton
      ref={accountButtonRef}
      kind="tertiary"
      variant="dark"
      startIcon={<LineBuildingIcon />}
      onClick={toggle}
    >
      <div>
        Account
        {!!balance && <Caption variant="small">
          <FormatCurrency value={balance} format="dynamicDollar" />
        </Caption>}
      </div>
    </TextButton>
    <DropdownList
      size="M"
      open={value && !isMobileScreen}
      title={MENU_TITLE}
      onClose={off}
      triggerRef={accountButtonRef}
      anchorRef={accountButtonRef}
      data-testid="business-traveller-account-menu"
    >
      <BusinessTravellerAccountMenuContent onListItemClick={off} />
    </DropdownList>
  </Group>
})

function mapStateToProps(state: App.State) {
  return {
    balance: state.auth.account.balance,
  }
}

export default connect(mapStateToProps)(BusinessTravellerAccountButtonMenu)
